import { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";
import useUsers from "./useUsers";

export default function UsersSelect({ onChangeUser }) {
  const [search, setSearch] = useState('');

  const { data, loading } = useUsers({ search });

  const options = data?.map(item => {
    return {
      id: item.id,
      name: item.nome,
      email: item.email
    }
  })

  return (
    <Autocomplete
      options={options}
      loading={loading}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `[${option.id}] ${option.name} [${option.email}]`}
      loadingText="Buscando alunos"
      noOptionsText="Nenhum aluno encontrado"
      onChange={(e, newValue) => onChangeUser(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Selecione o aluno"
          value={search}
          onChange={e => setSearch(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={16} color="inherit" /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}